import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgIf } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ListContainerComponent } from '../list-container/list-container.component';

@Component({
    selector: '[lSortable]',
    templateUrl: './sort-icon.component.html',
    imports: [
        IconComponent,
        NgIf,
        TableModule
    ]
})
export class SortIconComponent {

  constructor(
    private readonly listContainer: ListContainerComponent<any>
  ) {
    this.listContainer.registerSortableColumn(this);
  }

  @Input({ required: true })
  public lSortable!: string;

  public get field(): string {
    return this.lSortable;
  }

  @Output()
  public changeOrder = new EventEmitter<1 | -1 | 0>();

  public simpleOrder: 1 | -1 | 0 = 0;

  public handlerOrder(): void {
    if (this.simpleOrder === 0) {
      this.simpleOrder = -1;
    } else if (this.simpleOrder === -1) {
      this.simpleOrder = 1;
    } else if (this.simpleOrder === 1) {
      this.simpleOrder = 0;
    }

    this.changeOrder.emit(this.simpleOrder);
  }

}
